module.exports = __webpack_public_path__ + "assets/img/37_1018.7b0b9673.jpg";